import { render, staticRenderFns } from "./RelatedPartiesModal.vue?vue&type=template&id=5a39f6de&scoped=true&"
import script from "./RelatedPartiesModal.vue?vue&type=script&lang=js&"
export * from "./RelatedPartiesModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a39f6de",
  null
  
)

export default component.exports